import Loading from "@/components/Loading";
import { signIn } from "next-auth/react";
import { useEffect } from "react";

export default function Page() {
  useEffect(() => {
    signIn("auth0", {
      callbackUrl: `${window.location.origin}/router`,
    });
  }, []);

  return <Loading />;
}
